module.exports = __webpack_public_path__ + "static/media/Stellar Max King Headboard - 180 cm_Cream.6ab1f0b4.png";